
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-tileset",
  "use": "icon-rescls-tileset-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-rescls-tileset\"><path fill=\"#3498db\" d=\"M12 12H0c.008-3.28-.017-6.561.013-9.841C.129.764 1.539-.18 2.875 0H12z\" /><path fill=\"#dce8f3\" d=\"M24 12H12V0c3.28.008 6.562-.017 9.841.013C23.236.129 24.18 1.539 24 2.875zM12 24V12H0c.008 3.28-.017 6.562.013 9.841C.129 23.236 1.539 24.18 2.875 24z\" /><path fill=\"#3498db\" d=\"M24 21.6V12H12v12c3.28-.008 6.562.017 9.841-.013 1.183-.111 2.173-1.195 2.159-2.387M12 6h6v6h-6zM12 18H6v-6h6zM18 0c1.334.026 2.675-.057 4.004.05C23.35.287 24.16 1.677 24 2.976V6h-6zM6 24c-1.334-.026-2.675.057-4.004-.05C.65 23.713-.16 22.323 0 21.024V18h6z\" /><path stroke=\"#dce8f3\" d=\"M24 12H0M12 24V0\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-tileset"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-tileset";

        export default Icon;
    